export default [
  {
    path: "#home",
    text: "Home",
    id: "home",
  },
  {
    path: "#aboutus",
    text: "About",
    id: "about",
  },
  {
    path: "#expertise",
    text: "Skills",
    id: "skills",
  },
  {
    path: "#projects",
    text: "Projects",
    id: "project",
  },
  {
    path: "#blog",
    text: "Blog",
    id: "blogs",
  },
  {
    path: "#contactus",
    text: "Contact",
    id: "contact",
  },
]
